import { useEffect, useState } from "react";
import { getCoordinatesFromAddress } from "./geolocation"; // Asegúrate de que la ruta sea correcta

function deg2rad(deg) {
    return deg * (Math.PI / 180);
}

function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radio de la Tierra en km
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

const useHealthCenterFilters = ({
                                    allCenters,
                                    selectedServices,
                                    selectedSpecialities,
                                    selectedDepartments,
                                    selectedLanguages,
                                    selectedInsurance,
                                    selectedMedicaid,
                                    selectedAccessibility,
                                    selectedRating,
                                    selectedHours,
                                    centerType,
                                    selectedAwards,
                                    selectedQualityAndAccreditation,
                                    location,
                                    distance,
                                    searchTerm,
                                    userCoords
                                }) => {
    const [filteredCenters, setFilteredCenters] = useState(allCenters);

    useEffect(() => {

        const applyFilters = async () => {
            let filtered = [...allCenters];

            const arrayIncludesAll = (dataArray, selectedArray) =>
                Array.isArray(dataArray) &&
                selectedArray.every((item) =>
                    dataArray.map((v) => v.toLowerCase()).includes(item.toLowerCase())
                );

            if (searchTerm && searchTerm.trim() !== "") {
                filtered = filtered.filter((center) =>
                    center.name?.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }

            if (selectedServices.length > 0) {
                filtered = filtered.filter((center) =>
                    arrayIncludesAll(center.services, selectedServices)
                );
            }

            if (selectedSpecialities.length > 0) {
                filtered = filtered.filter((center) =>
                    arrayIncludesAll(center.specialties, selectedSpecialities)
                );
            }

            if (selectedDepartments.length > 0) {
                filtered = filtered.filter((center) =>
                    arrayIncludesAll(center.departments, selectedDepartments)
                );
            }

            if (selectedLanguages.length > 0) {
                filtered = filtered.filter((center) =>
                    arrayIncludesAll(center.languages, selectedLanguages)
                );
            }

            if (selectedInsurance.length > 0) {
                filtered = filtered.filter((center) =>
                    arrayIncludesAll(center.insurance, selectedInsurance)
                );
            }

            if (selectedMedicaid.length > 0) {
                filtered = filtered.filter((center) => {
                    const hasMedicaid = center.medicaid === true ? "Yes" : "No";
                    return selectedMedicaid.includes(hasMedicaid);
                });
            }

            if (selectedAccessibility.length > 0) {
                filtered = filtered.filter((center) =>
                    arrayIncludesAll(center.accessibility, selectedAccessibility)
                );
            }

            if (selectedRating !== null) {
                filtered = filtered.filter((center) => center.rating >= selectedRating);
            }

            if (selectedHours.length > 0) {
                filtered = filtered.filter((center) =>
                    arrayIncludesAll(center.hours, selectedHours)
                );
            }

            if (centerType && centerType !== "Any") {
                filtered = filtered.filter(
                    (center) =>
                        center.type?.toLowerCase() === centerType.toLowerCase()
                );
            }

            if (selectedAwards !== "Any") {
                filtered = filtered.filter(
                    (center) =>
                        center.awards?.toLowerCase() === selectedAwards.toLowerCase()
                );
            }

            if (selectedQualityAndAccreditation !== "Any") {
                filtered = filtered.filter(
                    (center) =>
                        center.qualityAndAccreditation?.toLowerCase() ===
                        selectedQualityAndAccreditation.toLowerCase()
                );
            }

            console.log("🧪 Verificando filtro de localización:");
            console.log("📍 location:", location);
            console.log("📏 distance:", distance);
            console.log("🧭 userCoords:", userCoords);
            // 📍 Filtro por ubicación
            if (location.trim() !== "" && distance > 0 && userCoords) {
                console.log("✅ Filtro de localización ACTIVADO");
                const updatedCenters = await Promise.all(filtered.map(async (center) => {
                    // Si ya tiene coordenadas, las usamos
                    if (!center.latitude || !center.longitude) {
                        const coords = await getCoordinatesFromAddress(center.address);

                        console.log("📦 Centro:", center.name);
                        console.log("📍 Dirección:", center.address);
                        console.log("📌 Coordenadas obtenidas:", coords);

                        if (coords) {
                            return {
                                ...center,
                                latitude: coords.lat,
                                longitude: coords.lng
                            };
                        } else {
                            console.warn("❌ No se pudo geocodificar:", center.address);
                            return null; // descartar centro inválido
                        }
                    }

                    return center; // ya tenía coordenadas
                }));

                const validCenters = updatedCenters.filter(Boolean); // elimina los null

                filtered = validCenters.filter((center) => {
                    const dist = getDistanceFromLatLonInKm(
                        userCoords.lat,
                        userCoords.lng,
                        center.latitude,
                        center.longitude
                    );

                    console.log(`📏 ${center.name} está a ${dist.toFixed(2)} km`);

                    return dist <= distance;
                });
            }

            setFilteredCenters(filtered);
        };

        applyFilters();
    }, [
        allCenters,
        searchTerm,
        selectedServices,
        selectedSpecialities,
        selectedDepartments,
        selectedLanguages,
        selectedInsurance,
        selectedMedicaid,
        selectedAccessibility,
        selectedRating,
        selectedHours,
        centerType,
        selectedAwards,
        selectedQualityAndAccreditation,
        location,
        distance,
        userCoords
    ]);

    return filteredCenters;
};

export default useHealthCenterFilters;
